/**
 * StopOver.js
 *
 * @description :: A model definition.  Represents a database table/collection/etc.
 * @docs        :: https://sailsjs.com/docs/concepts/models-and-orm/models
 */

export default {

  // tableName: 'paradas',

  attributes: {

    //  ╔═╗╦═╗╦╔╦╗╦╔╦╗╦╦  ╦╔═╗╔═╗
    //  ╠═╝╠╦╝║║║║║ ║ ║╚╗╔╝║╣ ╚═╗
    //  ╩  ╩╚═╩╩ ╩╩ ╩ ╩ ╚╝ ╚═╝╚═╝

    startedAt: {
      type: 'ref',
      columnType: 'datetime',
      required: true,
      // columnName: 'fecha_inicio'
    },

    finishedAt: {
      type: 'ref',
      columnType: 'datetime',
      required: true,
      // columnName: 'fecha_terminacion'
    },

    lat: {
      type: 'number',
      required: true,
      // columnName: 'latitud'
    },

    lng: {
      type: 'number',
      required: true,
      // columnName: 'longitud'
    },

    address: {
      type: 'string',
      required: true,
      // columnName: 'domicilio'
    },

    //  ╔═╗╔╦╗╔╗ ╔═╗╔╦╗╔═╗
    //  ║╣ ║║║╠╩╗║╣  ║║╚═╗
    //  ╚═╝╩ ╩╚═╝╚═╝═╩╝╚═╝


    //  ╔═╗╔═╗╔═╗╔═╗╔═╗╦╔═╗╔╦╗╦╔═╗╔╗╔╔═╗
    //  ╠═╣╚═╗╚═╗║ ║║  ║╠═╣ ║ ║║ ║║║║╚═╗
    //  ╩ ╩╚═╝╚═╝╚═╝╚═╝╩╩ ╩ ╩ ╩╚═╝╝╚╝╚═╝

    dispatch: {
      model: 'dispatch',
      // columnName: 'viaje_id'
    },

  },

}




// WEBPACK FOOTER //
// ./src/models/StopOver.js